import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["gasBoiler", "gasStove", "gasWaterHeater", "heatedArea", "residentCount", "submitButton"]

  connect() {
    this.boundEnableSubmit = this.enableSubmit.bind(this);
    this.boundDisableSubmit = this.disableSubmit.bind(this);
    this.element.addEventListener('input', this.boundEnableSubmit);
    this.element.addEventListener('change', this.boundDisableSubmit);
  }

  disconnect() {
    this.element.removeEventListener('input', this.boundEnableSubmit);
    this.element.removeEventListener('change', this.boundDisableSubmit);
  }

  toggleGasBoilerField() {
    const isChecked = this.gasBoilerTarget.checked;
    this.heatedAreaTarget.classList.toggle('d-none', !isChecked);

    if (!isChecked) {
      const input = this.heatedAreaTarget.querySelector('input');
      if (input) input.value = '';
    }
  }

  toggleResidentCountField() {
    const gasStoveChecked = this.gasStoveTarget.checked;
    const gasWaterHeaterChecked = this.gasWaterHeaterTarget.checked;
    const shouldShow = gasStoveChecked || gasWaterHeaterChecked;

    this.residentCountTarget.classList.toggle('d-none', !shouldShow);

    if (!shouldShow) {
      const input = this.residentCountTarget.querySelector('input');
      if (input) input.value = '';
    }
  }

  enableSubmit() {
    if (this.hasSubmitButtonTarget && this.submitButtonTarget.disabled) {
      this.submitButtonTarget.disabled = false;
    }
  }

  disableSubmit() {
    if (!this.gasBoilerTarget.checked && !this.gasStoveTarget.checked && !this.gasWaterHeaterTarget.checked) {
      this.submitButtonTarget.disabled = true;
    }
  }
}
